import { render, staticRenderFns } from "./GeneralInput.vue?vue&type=template&id=63c24da4&"
import script from "./GeneralInput.vue?vue&type=script&lang=js&"
export * from "./GeneralInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports